import React from 'react';
var FlechaAbajo = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "6.479", height: "6.647", viewBox: "0 0 6.479 6.647" },
        React.createElement("path", { id: "Icon_awesome-arrow-down", "data-name": "Icon awesome-arrow-down", d: "M6.442,5.076l.329.329a.355.355,0,0,1,0,.5L3.889,8.792a.355.355,0,0,1-.5,0L.5,5.908a.355.355,0,0,1,0-.5l.329-.329a.356.356,0,0,1,.509.006l1.7,1.788V2.606A.355.355,0,0,1,3.4,2.25h.475a.355.355,0,0,1,.356.356V6.87l1.7-1.788A.354.354,0,0,1,6.442,5.076Z", transform: "translate(-0.397 -2.25)", fill: "var(--icon-primary-dark)" })));
};
FlechaAbajo.defaultProps = {
    className: '',
};
export default FlechaAbajo;
